import React, { useCallback } from "react";
import { useUILocale } from "../../UILocale";
import { ConfirmDialog } from "../ConfirmDialog";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  DialogContentText,
  Typography,
} from "@mui/material";
import { useDialog } from "../useDialog";
import { getErrorDetails } from "./getErrorDetails";
import { ErrorDialogOptions } from "./ErrorDialogContext";

export const useGenericErrorDialog = () => {
  const { dialogProps, openDialog, closeDialog } = useDialog();
  const {
    dialog: {
      genericError: { headline, body, confirmButton, showDetails },
    },
  } = useUILocale();

  const [error, setError] = React.useState<unknown>(null);
  const [options, setOptions] = React.useState<ErrorDialogOptions>({});
  const openGenericErrorDialog = useCallback(
    (error: unknown, opts?: ErrorDialogOptions) => {
      setError(error);
      setOptions(opts || {});
      openDialog();
    },
    [openDialog],
  );

  const handleConfirm = () => {
    if (options.onConfirm) {
      options.onConfirm();
      closeDialog();
    } else {
      window.location.reload();
    }
  };

  const dialog = (
    <ConfirmDialog
      id="generic-error-dialog"
      headline={headline}
      {...dialogProps}
      useSingleAction
      confirmButtonText={options.confirmButtonText || confirmButton}
      onConfirm={handleConfirm}
    >
      <DialogContentText>{body}</DialogContentText>
      <Accordion sx={{ mt: 2 }}>
        <AccordionSummary>{showDetails}</AccordionSummary>
        <AccordionDetails>
          {options.hint && (
            <Typography variant="body2" color="error.main" sx={{ mb: 2 }}>
              {options.hint}
            </Typography>
          )}
          {getErrorDetails(error)}
        </AccordionDetails>
      </Accordion>
    </ConfirmDialog>
  );
  return { genericErrorDialog: dialog, openGenericErrorDialog };
};
